import { AssignmentGroup } from 'app/models/dto/lead-assignment/assignment-group.model';
import { Lender } from 'app/models/dto/lead-assignment/lender.model';

export class GetLeadAssignmentGroups {
  static readonly type = '[LeadAssignment] Get Lead Assignment Groups';
  constructor() {}
}

export class GetClassifications {
  static readonly type = '[LeadAssignment] Get Classification';
  constructor() {}
}

export class GetSources {
  static readonly type = '[LeadAssignment] Get Sources';
  constructor() {}
}

export class SetSelectedAssignmentGroup {
  static readonly type = '[LeadAssignment] Set SelectedAssignmentGroup';
  constructor(public selectedAssignmentGroup: AssignmentGroup | null) {}
}

export class SetSelectedAssignmentGroupAttributes {
  static readonly type = '[LeadAssignment] Set SetSelectedAssignmentGroupAttributes';
  constructor(public assignments: Lender[]) {}
}

export class SetNewBucket {
  static readonly type = '[LeadAssignment] Set NewBucket';
  constructor(public newBucket: boolean) {}
}

export class IncrementChangesMade {
  static readonly type = '[LeadAssignment] IncrementChangesMade';
}

export class checkIfValid {
  static readonly type = '[LeadAssignment] CheckIfValid';
  constructor(public valid: boolean) {}
}

export class ResetChangesMade {
  static readonly type = '[LeadAssignment] ResetChangesMade';
}

export class DeleteBucket {
  static readonly type = '[LeadAssignment] Delete Bucket';
  constructor(public id: number) {}
}

export class GetUnclaimedLeadsTotals {
  static readonly type = '[LeadAssignment] Get Unclaimed Leads Totals';
  constructor(public id: number) {}
}

export class ClearAssignmentGroups {
  static readonly type = '[ClearAssignmentGroups] Clear Assignment Groups';
  constructor() {}
}
export class GetMQLCount {
  static readonly type = '[LeadAssignment] Get MQL Count';
  constructor() {}
}
